module.exports = [{
      plugin: require('/Users/msiara/Projects/portfolio/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"head":false,"trackingId":"UA-127729463-1"},
    }]
